import React from 'react'
import styles from '../index.module.scss'
import InputCustom from '../../atoms/input/InputCustom'
import { Grid } from '@mui/material'
import SelectCustom from '../../atoms/select/SelectCustom'

const Photographer = () => {
	return (
		<>
			<div>
				<h3 className={styles.Title}>
					Photographer/Videographer Survey
				</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Company contact name
							</label>
							<InputCustom
								placeholder="Enter Company contact name"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Company Contact Number
							</label>
							<InputCustom
								placeholder="Enter Company Contact Number"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Number of Hours Booked
							</label>
							<InputCustom
								placeholder="Enter Number of Hours Booked"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Second Shooter or Assistant
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Videographer Included?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Photo Details</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Are you capturing a first look?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Pre-ceremony wedding party photos?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Post-ceremony send-off photos?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Post-ceremony family formals?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Sunset / golden-hour photos?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Sparkler send-off or late-night photos?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								How many portrait locations total?
							</label>
							<InputCustom
								placeholder="Enter portrait locations"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Timeline Contributions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Arrival/load-in time
							</label>
							<InputCustom
								placeholder="Enter arrival/load-in time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Coverage start time
							</label>
							<InputCustom
								placeholder="Enter coverage start time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Coverage end time
							</label>
							<InputCustom
								placeholder="Enter coverage end time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Travel time between locations
							</label>
							<InputCustom
								placeholder="Enter travel time between locations"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Ideal lighting window for main portraits
							</label>
							<InputCustom
								placeholder="Enter"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Requested buffer time before ceremony
							</label>
							<InputCustom
								placeholder="Enter requested buffer time before ceremony"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Dependencies</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								What vendor categories do you need to coordinate
								with?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Notes</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Any other notes for the couple?
							</label>
							<InputCustom
								placeholder="Enter notes"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Other Questions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Rain contingency or setup change needed?
							</label>
							<InputCustom
								placeholder="Enter notes"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Setup / teardown duration
							</label>
							<InputCustom
								placeholder="Enter setup/teardown duration"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Special equipment or space needs?
							</label>
							<InputCustom
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Contact for day-of emergencies
							</label>
							<InputCustom
								placeholder="Enter contact for day-of emergencies"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default Photographer
